export enum KindOper {
  Add,
  Edit,
  Preview,
  PreviewClient,
  Copy,
  Verify,
  EditClient,
  EditStepByStep,
  EditStepByStepClient
}
